var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 46,
    fill: "#E7EEDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#71805C",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 61.5c0-9.6 6.3-17.5 14-17.5s14 7.9 14 17.5v8.2c0 10.1-6.3 18.3-14 18.3s-14-8.2-14-18.3v-8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 50.5c.9-6.9 5.2-11.5 11-11.5 5.4 0 9.6 3.8 10.8 9.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 47.5c.3-4 3.1-7 6.8-7 3.4 0 6.2 2.4 6.8 5.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2 63.5c-4.3.2-7.7 3.5-7.7 7.6 0 4.3 3.5 7.8 7.8 7.8M77.8 63.5c4.3.2 7.7 3.5 7.7 7.6 0 4.3-3.5 7.8-7.8 7.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4 64.8h.1M69.5 64.8h.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2 74.3c1.4 1.4 3 2.1 4.8 2.1 1.8 0 3.4-.7 4.8-2.1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.bcea6eba1928d83dea625f0957930d01.svg";
export { ForwardRef as ReactComponent };